import React, { useRef, useContext } from 'react';
import classnames from 'classnames';
import { isDropdownGroup } from '../../../helpers';
import { useDropdownItems } from '../../../hooks/useDropdownItems';
import StandardMenuOption from '../StandardMenuOption';
import StandardMenuGroup from '../StandardMenuGroup';
import { NavigationDirection, useStandardMenuKeyboardSupport } from '../hooks';
import { itemWithOnSelect } from '../utils';
import StandardMenuContext from '../context';
import { StandardMenuType } from '../types';
import s from './StandardMenuContent.scss';
const StandardMenuContent = ({ id, children, lightText, withBottomPaddings, className, onSelect, items, groupClassName, itemClassName, hideCheckIcon, withHoverEffect })=>{
    const { menuType, role } = useContext(StandardMenuContext);
    const { filteredItems } = useDropdownItems(items);
    const { currentItemIndex, navigationDirection, groupStartingItemIndex, handleKeyboardEvents, focusNextItem, focusPreceedingItem, focusFirstItem, focusLastItem, focusItemByPhrase, clearFocus } = useStandardMenuKeyboardSupport(filteredItems);
    const containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        id: id,
        role: role,
        "data-testid": "menu",
        className: classnames(s['menu'], lightText && s['light-text'], !withBottomPaddings && s['without-bottom-padding'], className),
        /* TODO: Figure out a way to handle nested groups here
      aria-activedescendant={
        currentItemIndex !== null
          ? `${id}-option-${currentItemIndex}`
          : undefined
      }
      */ onKeyDown: handleKeyboardEvents,
        tabIndex: 0,
        onBlur: (e)=>{
            if (containerRef.current && (!e.relatedTarget || !containerRef.current.contains(e.relatedTarget)) && menuType === StandardMenuType.EMBEDDED) {
                clearFocus();
            }
        },
        onFocus: (e)=>{
            // DROPDOWN types have their focus managed via which key the dropdown was opened with.
            if (menuType === StandardMenuType.EMBEDDED && e.target === containerRef.current) focusFirstItem();
        }
    }, filteredItems.map((item, idx)=>isDropdownGroup(item) ? /*#__PURE__*/ React.createElement(StandardMenuGroup, {
            id: `${id}-group-${idx}`,
            item: item,
            className: groupClassName,
            itemClassName: itemClassName,
            hideCheckIcon: hideCheckIcon,
            withHoverEffect: withHoverEffect,
            onPassGroupStart: focusPreceedingItem,
            onPassGroupEnd: focusNextItem,
            onPressHome: focusFirstItem,
            onPressEnd: focusLastItem,
            onSearch: focusItemByPhrase,
            // Make sure we start from the bottom of the group if we're traveling up in the list
            startIndexOnFocus: groupStartingItemIndex !== null ? groupStartingItemIndex : navigationDirection === NavigationDirection.UP ? item.items.length - 1 : 0,
            onSelect: onSelect,
            key: item.label || `item_${idx}`,
            focused: idx === currentItemIndex
        }) : /*#__PURE__*/ React.createElement(StandardMenuOption, {
            id: `${id}-option-${idx}`,
            key: item.value || `item_${idx}`,
            item: itemWithOnSelect(item, onSelect),
            className: itemClassName,
            hideCheckIcon: hideCheckIcon,
            withHoverEffect: withHoverEffect,
            focused: idx === currentItemIndex
        })), children);
};
StandardMenuContent.displayName = 'StandardMenuContent';
export default StandardMenuContent;
